
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import formatNumber from '@/shared/filters/format-number';
import { BillOfLadingModel } from '@/models/bill-of-lading';
@Component
export default class BillOfLading extends Vue {

    @Prop({default: []})
    private packages!: BillOfLadingModel[];
}
